module.exports = __webpack_public_path__ + "img/login_banner1.c29bc7ce.png";